import { z } from 'zod';

const fieldText = z.object({
  id: z.string(),
  name: z
    .string({ error: 'Name is required' })
    .trim()
    .min(1, { message: 'Name is required' }),
  required: z.boolean(),
  type: z.literal('text'),
});

const fieldRichText = z.object({
  id: z.string(),
  name: z
    .string({ error: 'Name is required' })
    .trim()
    .min(1, { message: 'Name is required' }),
  required: z.boolean(),
  type: z.literal('rich'),
});

const fieldComponent = z.object({
  componentId: z.string(),
  id: z.string(),
  name: z
    .string({ error: 'Name is required' })
    .trim()
    .min(1, { message: 'Name is required' }),
  required: z.boolean(),
  type: z.literal('component'),
});

export const fieldSchemaDefV1 = z.object({
  fields: z.array(z.union([fieldText, fieldRichText, fieldComponent])),
  version: z.literal(1),
});
